import type { CreateEntry } from "@roman/shared/types/CreateEntry";
import type { RoundDetails } from "@roman/shared/types/RoundDetails";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type EntryActions = {
  setPlayerIds: (playerIds: CreateEntry["playerIds"]) => void;
  setCaptainAndViceCaptain: (
    type: CreateEntry["detail"]["type"],
    captainPlayerId: string,
    viceCaptainPlayerId: string,
  ) => void;
  setEntryDetails: (entryDetails: CreateEntry) => void;
  setRound: (round: RoundDetails | null) => void;
  resetAll: () => void;
};

type EntryState = {
  entryDetails: CreateEntry;
  round: RoundDetails | null;
};

const initialState: EntryState = {
  entryDetails: {
    playerIds: [],
    entries: [],
    detail: {
      type: "0001",
      captainPlayerId: "",
    },
  },
  round: null,
};

export const useEntryStore = create<EntryState & EntryActions>()(
  immer((set) => ({
    ...initialState,
    setPlayerIds: (playerIds) =>
      set((state) => {
        state.entryDetails.playerIds = playerIds;
      }),
    setCaptainAndViceCaptain: (type, captainPlayerId, viceCaptainPlayerId) =>
      set((state) => {
        state.entryDetails.detail = {
          type,
          captainPlayerId,
          viceCaptainPlayerId,
        };
      }),
    setEntryDetails: (entryDetails) =>
      set((state) => {
        state.entryDetails = entryDetails;
      }),
    setRound: (round: RoundDetails | null) =>
      set((state) => {
        state.round = round;
      }),
    resetAll: () => set(() => initialState),
  })),
);
